import p5 from 'p5';
import { IonPainter } from './IonPainter';

export class Wall {
  private _p5: IonPainter;
  public a: p5.Vector;
  public b: p5.Vector;

  constructor (P5: IonPainter, x1: number, y1: number, x2: number, y2: number) {
    this._p5 = P5;
    this.a = this._p5.createVector(x1, y1);
    this.b = this._p5.createVector(x2, y2);
  }

  show (): void {
    this._p5.stroke(255);
    this._p5.line(this.a.x, this.a.y, this.b.x, this.b.y);
  }
}
